module.exports = __webpack_public_path__ + "img/logo2.b68f8447.png";